import { Skeleton } from "antd";

export default function PurchaseItemSkeleton() {
  return (
    <section className="w-full">
      <div className="flex items-center space-x-3">
        <div className="w-[185px] h-[48px] purchase-input">
          <Skeleton.Input active={true} size={"square"} block={true} />
        </div>
        <div className="w-[82px] h-[48px] purchase-input">
          <Skeleton.Input active={true} size={"square"} block={true} />
        </div>
        <div className="w-[90px] h-[48px] purchase-input">
          <Skeleton.Input active={true} size={"square"} block={true} />
        </div>
        <div className="w-[83px] h-[48px] purchase-input">
          <Skeleton.Input active={true} size={"square"} block={true} />
        </div>
        <div className="w-[87px] h-[48px] purchase-input">
          <Skeleton.Input active={true} size={"square"} block={true} />
        </div>
        <div className="w-[120px] h-[48px] purchase-input">
          <Skeleton.Input active={true} size={"square"} block={true} />
        </div>
        <div className="w-[126px] h-[48px] purchase-input">
          <Skeleton.Input active={true} size={"square"} block={true} />
        </div>
        <div className="w-[152px] h-[48px] purchase-input">
          <Skeleton.Input active={true} size={"square"} block={true} />
        </div>
      </div>
    </section>
  );
}
